/**
 * Filestack only supports: ca, da, de, en, es, fr, he, it, ja, ko, nl, no, pl, pt, sv, ru, vi, zh, tr
 * Alfred languages NOT supported: cs (Czech), el (Greek), hu (Hungarian)
 */

const FILESTACK_SUPPORTED_LANGS = new Set([
  'ca',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'he',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ru',
  'sv',
  'tr',
  'vi',
  'zh',
])

const DEFAULT_LANG = 'en'

export function getFilestackLang(appLocale: string): string {
  if (!appLocale) {
    return DEFAULT_LANG
  }

  const baseLang = appLocale.split('-')[0]?.toLowerCase() ?? DEFAULT_LANG

  return FILESTACK_SUPPORTED_LANGS.has(baseLang) ? baseLang : DEFAULT_LANG
}
